export default __webpack_public_path__ + "hardware.svg";